import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { constantField, Form, selectBox, textBox } from "trader.ts/ui.forms";
import * as style from "../../../styles/style.css.classes";
import { renderCancelButton, renderSaveButton } from "../../client/savebutton";
import * as routes from "../../routes";
import { counterparty } from "../messages/client";

export function render(opts: {
  possibleCounterparties: {
    name: string;
    counterparty: counterparty;
    own_identity: {
      counterparty: counterparty;
      name: string;
    };
  }[];
}): HTMLElement | HTMLElement[] {
  const form = new Form({})
    .addField("own_identity", [], () => {
      const values = opts.possibleCounterparties
        .map((cp) => cp.own_identity)
        .uniqBy((identity) => JSON.stringify(identity))
        .orderBy((cp) => cp.name);
      if (values.length === 1) {
        return constantField(values[0]);
      } else {
        return selectBox({
          values,
          initial: undefined,
          show: (cp) => cp.name,
          label: "Als wie wil je een bericht sturen?",
        });
      }
    })
    .addField("counterparty", ["own_identity"], ({ own_identity }) => {
      const values = opts.possibleCounterparties
        .filter((cp) => cp.own_identity.name === own_identity.name)
        .uniqBy((cp) => cp.name)
        .orderBy(
          [(cp) => (cp.counterparty.tag === "Admin" ? 1 : 0), (cp) => cp.name],
          ["desc", "asc"],
        );
      return selectBox({
        values,
        initial: undefined,
        show: (cp) => cp.name,
        label: "Naar wie wil je een bericht sturen?",
      });
    })
    .addField("message", ["counterparty"], () =>
      textBox({ label: "Bericht", type: "textarea" }),
    )
    .build();
  return (
    <div className={style.card_student_start}>
      <section>{form.render()}</section>

      <div style="text-align: right">
        {renderCancelButton({
          onclick: () =>
            (document.location = routes.student_start_messagesRoute.link()),
        })}
        {renderSaveButton({
          formS: form.s,
          save: async (f) => {
            await rpc(routes.sendMessageSpec, undefined, {
              counterparty: f.counterparty.counterparty,
              own_identity: f.own_identity.counterparty,
              message: f.message,
            });
            return { tag: "success" };
          },
          reload: (f) =>
            (document.location =
              routes.student_start_messages_historyRoute.link({
                target: {
                  own_identity: f.own_identity.counterparty,
                  counterparty: f.counterparty.counterparty,
                },
              })),
          timeout: 1500,
        })}
      </div>
    </div>
  );
}
